import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  ROOMS: [],
  CATEGORY: [],
  MESSAGES: [],
  categoryLoading: false,
  totalCount: 0,
};

const slice = createSlice({
  name: "ROOMS",
  initialState: initialState,
  reducers: {
    addMessage: (state, action) => {
      state.MESSAGES.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Act.getRoomList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getRoomList.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      ROOMS: payload.data,
      totalCount: payload.total_record_count,
    }));
    builder.addCase(Act.getRoomList.rejected, (state, action) => ({
      ...state,
      loading: false,
      ROOMS: [],
      totalCount: 0,
    }));
    builder.addCase(Act.addRoom.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.addRoom.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.addRoom.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.editRoom.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.editRoom.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.editRoom.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.getCategoryList.pending, (state, action) => ({
      ...state,
      categoryLoading: true,
    }));
    builder.addCase(Act.getCategoryList.fulfilled, (state, { payload }) => ({
      ...state,
      categoryLoading: false,
      CATEGORY: payload.data,
      totalCount: payload.total_record_count,
    }));
    builder.addCase(Act.getCategoryList.rejected, (state, action) => ({
      ...state,
      categoryLoading: false,
      CATEGORY: [],
      totalCount: 0,
    }));
    builder.addCase(Act.addCategory.pending, (state, action) => ({
      ...state,
      categoryLoading: true,
    }));
    builder.addCase(Act.addCategory.fulfilled, (state, { payload }) => ({
      ...state,
      categoryLoading: false,
    }));
    builder.addCase(Act.addCategory.rejected, (state, action) => ({
      ...state,
      categoryLoading: false,
    }));
    builder.addCase(Act.getMessageList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getMessageList.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      MESSAGES: payload.data,
    }));
    builder.addCase(Act.getMessageList.rejected, (state, action) => ({
      ...state,
      loading: false,
      MESSAGES: [],
    }));
    builder.addCase(Act.ediCategory.pending, (state, action) => ({
      ...state,
      categoryLoading: true,
    }));
    builder.addCase(Act.ediCategory.fulfilled, (state, { payload }) => ({
      ...state,
      categoryLoading: false,
    }));
    builder.addCase(Act.ediCategory.rejected, (state, action) => ({
      ...state,
      categoryLoading: false,
    }));
    builder.addCase(Act.getCategoryListAll.pending, (state, action) => ({
      ...state,
      categoryLoading: true,
    }));
    builder.addCase(Act.getCategoryListAll.fulfilled, (state, { payload }) => ({
      ...state,
      categoryLoading: false,
      CATEGORY: payload.data,
      totalCount: payload.total_record_count,
    }));
    builder.addCase(Act.getCategoryListAll.rejected, (state, action) => ({
      ...state,
      categoryLoading: false,
      CATEGORY: [],
      totalCount: 0,
    }));
  },
});

export default slice;
export const { addMessage } = slice.actions;
